<template>
<div id='device-alerts'>
    <h4><b-icon icon="exclamation-triangle"></b-icon><span>Ilmoitukset</span></h4>
    <div>
    <div v-for="alert in alerts" :key="alert.id" class='device-alert'>
        <b-icon v-if="alert.status == 'ERROR'" icon="exclamation-triangle-fill" class='error' />
        <b-icon v-if="alert.status == 'WARNING'" icon="exclamation-triangle-fill" class='warning' />
        <b-icon v-if="alert.status == 'OK'" icon="check-square-fill" class='ok' />
        <div class='details'>
            <div class="time"> {{ getAlertDate() }} {{ alert.time }}</div>
            <div class='station'> [{{ alert.device }}] {{ alert.station }} </div>
            <!--div class='device'>{{ error.id }}</div-->
            <div class='event'>{{ alert.event }}</div>
        </div>
    </div>
    </div>
    <a href="#" class='link'><b-icon icon="chevron-down"></b-icon>Näytä aiemmat</a>
</div>
</template>


<script>

import moment from "moment";

export default ({
    data: function() {
        return  { 
            alerts: [
                { id: 1, device: "FIN-INFO-3", station: "Finnoo", status: "ERROR", event: "Ei yhteyttä laitteeseen.", time: "13:02" },
                { id: 2, device: "KEI-INFO-3", station: "Keilaniemi", status: "ERROR", event: "Ei yhteyttä laitteeseen.", time: "10:37" },
                { id: 3, device: "HER-INFO-3", station: "Herttoniemi", status: "OK", event: "Yhteys laitteeseen palautunut.", time: "09:19" },
                { id: 4, device: "HER-INFO-3", station: "Herttoniemi", status: "ERROR", event: "Ei yhteyttä laitteeseen.", time: "09:03" },
                { id: 5, device: "HAK-INFO-3", station: "Hakaniemi", status: "WARNING", event: "Laitteen levytilaa jäljellä 4%.", time: "08:15" }

            ]
         }
    },
    methods: {
        getAlertDate(){
            let aika = moment();
            return aika.format("D.M.YYYY");
        }
    }
})
</script>